<app-modal
  [title]="'Card Details' | trans:'cards/card-details-modal/header/title'"
  [textAfterTitle]="data?.card.cardNr"
  [compact]="false"
  maxWidth="1600px"
>
  <ng-template>
    @if (isLoading()) {
      <div class="d-flex justify-content-center full-height align-items-center">
        <app-loader size="lg" />
      </div>
    } @else {
      @if (data.card && customerCardCardType()) {
        <app-toggle-tabs-menu
          [options]="toggleTabsMenuOptions"
          [(selectedIndex)]="selectedToggleTabsMenuOptionsIndex"
        />

        <div>
          @if (selectedToggleTabsMenuOptionsIndex === 0) {
            <ng-container [ngTemplateOutlet]="overviewTemplate" />
          } @else if (selectedToggleTabsMenuOptionsIndex === 1) {
            <div class="d-flex gap-48 m-t-24">
              <div class="flex-grow-1 w-0">
                <app-actions-history-table [cardActionsHistory]="data.card.actionHistory" />
              </div>

              <div class="left-separator p-l-48 flex-grow-1 w-0">
                <div class="d-flex flex-direction-column gap-80">
                  <app-card-products-table
                    [card]="data.card"
                    (cardUpdated)="data = { card: $event }"
                  />

                  <app-card-free-entries-table
                    [card]="data.card"
                    (cardUpdated)="data = { card: $event }"
                  />
                </div>
              </div>
            </div>
          } @else if (selectedToggleTabsMenuOptionsIndex === 2) {
            <app-card-transactions-table class="m-t-24 d-block" [card]="data.card" />
          } @else if (selectedToggleTabsMenuOptionsIndex === 3) {
            <app-card-tickets-history-table class="m-t-24 d-block" [card]="data.card" />
          }
        </div>
      }
    }
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      <button
        class="button button--md button--primary-ghost text-uppercase"
        (click)="isActionMaking.set(true); detachCardFromCart();"
        [disabled]="isActionMaking()"
      >
        {{ 'Detach card' | trans:'cards/card-details-modal/detachCard.Button' }}
      </button>

      <button
        class="button button--md button--primary text-uppercase"
        (click)="close()"
      >
        {{ 'Cancel' | trans:'cards/card-details-modal/cancel.Button' }}
      </button>
    </div>
  </ng-container>
</app-modal>

<ng-template #overviewTemplate>
  <div class="d-flex gap-24 m-t-16">
    <div class="flex-grow-1 w-0">
      <table class="full-width overview">
        <ng-container
          [ngTemplateOutlet]="overviewTableRow"
          [ngTemplateOutletContext]="{ label: ('Kunde' | trans:'cards/card-details-modal/overview/labeles.Customer'), value: data.card.customer, withEditClientButton: true }"
        />
        <ng-container
          [ngTemplateOutlet]="overviewTableRow"
          [ngTemplateOutletContext]="{ label: ('Company' | trans:'cards/card-details-modal/overview/labeles.Company'), value: data.card.companyName }"
        />

        <ng-container
          [ngTemplateOutlet]="overviewTableRow"
          [ngTemplateOutletContext]="{ label: ('Status' | trans:'cards/card-details-modal/overview/labeles.Status'), value: data.card.status, withTopSeparator: true, isCardStatus: true }"
        />
        <ng-container
          [ngTemplateOutlet]="overviewTableRow"
          [ngTemplateOutletContext]="{ label: ('Valid from' | trans:'cards/card-details-modal/overview/labeles.ValidFrom'), value: (data.card.validFrom | localeDateFormat) }"
        />
        <ng-container
          [ngTemplateOutlet]="overviewTableRow"
          [ngTemplateOutletContext]="{ label: ('Valid Until' | trans:'cards/card-details-modal/overview/labeles.ValidUntil'), value: (data.card.validUntil | localeDateFormat) }"
        />
        <ng-container
          [ngTemplateOutlet]="overviewTableRow"
          [ngTemplateOutletContext]="{ label: ('Last transaction' | trans:'cards/card-details-modal/overview/labeles.LastTransaction'), value: data.card.lastTransactionDate ? (data.card.lastTransactionDate | localeDateFormat) : null }"
        />

        <ng-container
          [ngTemplateOutlet]="overviewTableRow"
          [ngTemplateOutletContext]="{ label: ('Card number' | trans:'cards/card-details-modal/overview/labeles.CardNumber'), value: data.card.cardNr, withTopSeparator: true }"
        />
        <ng-container
          [ngTemplateOutlet]="overviewTableRow"
          [ngTemplateOutletContext]="{ label: ('Card type' | trans:'cards/card-details-modal/overview/labeles.CardType'), value: data.card.cardType }"
        />
        <ng-container
          [ngTemplateOutlet]="overviewTableRow"
          [ngTemplateOutletContext]="{ label: ('Card model' | trans:'cards/card-details-modal/overview/labeles.CardModel'), value: data.card.cardModel }"
        />
        <ng-container
          [ngTemplateOutlet]="overviewTableRow"
          [ngTemplateOutletContext]="{ label: ('Card issuer' | trans:'cards/card-details-modal/overview/labeles.CardIssuer'), value: data.card.cardIssuer }"
        />

        <ng-container
          [ngTemplateOutlet]="overviewTableRow"
          [ngTemplateOutletContext]="{ label: ('Bonus points' | trans:'cards/card-details-modal/overview/labeles.BonusPoints'), value: data.card.bonusPoints, withTopSeparator: true }"
        />
        <ng-container
          [ngTemplateOutlet]="overviewTableRow"
          [ngTemplateOutletContext]="{ label: ('Bonus program' | trans:'cards/card-details-modal/overview/labeles.BonusProgram'), value: data.card.bonusProgramName }"
        />
        <ng-container
          [ngTemplateOutlet]="overviewTableRow"
          [ngTemplateOutletContext]="{ label: ('Free entries' | trans:'cards/card-details-modal/overview/labeles.FreeEntries'), value: data.card.freeEntries }"
        />

        <ng-container
          [ngTemplateOutlet]="overviewTableRow"
          [ngTemplateOutletContext]="{ label: ('Mnimum load amount' | trans:'cards/card-details-modal/overview/labeles.MinimumLoadAmount'), value: ((customerCardCardType().minLoadAmount | numberToCurrency) + ' ' + languageConfig.currency.short), withTopSeparator: true }"
        />
        <ng-container
          [ngTemplateOutlet]="overviewTableRow"
          [ngTemplateOutletContext]="{ label: ('Maximum load amount' | trans:'cards/card-details-modal/overview/labeles.MaximumLoadAmount'), value: ((customerCardCardType().maxLoadAmount | numberToCurrency) + ' ' + languageConfig.currency.short) }"
        />
        <ng-container
          [ngTemplateOutlet]="overviewTableRow"
          [ngTemplateOutletContext]="{ label: ('Maximum card amount' | trans:'cards/card-details-modal/overview/labeles.MaximumCardAmount'), value: ((customerCardCardType().maximumAmount | numberToCurrency) + ' ' + languageConfig.currency.short) }"
        />

        <ng-container
          [ngTemplateOutlet]="overviewTableRow"
          [ngTemplateOutletContext]="{ label: ('Current balance' | trans:'cards/card-details-modal/overview/labeles.CurrentBalance'), value: data.card.currentBalance, withTopSeparator: true, isCurrentBalanace: true }"
        />
      </table>
    </div>

    <div class="left-separator p-l-24 flex-grow-1 w-0">
      <div class="d-flex flex-direction-column gap-24">
        <div>
          <p class="t2 c-t-gray-500 fw-medium text-uppercase">
            {{ 'Transaction' | trans:'cards/card-details-modal/action-buttons/groups/transaction.Label' }}
          </p>

          <div class="m-t-8 d-flex flex-direction-column gap-12 align-items-start">
            @if (data.card.status === cardStatuses.CRD_ACTIVATED || data.card.status === cardStatuses.CRD_DEACTIVATED) {
              <button
                class="button button--md button--primary-ghost text-uppercase p2 fw-semibold"
                [disabled]="isActionMaking() || data.card.status !== cardStatuses.CRD_ACTIVATED && data.card.status !== cardStatuses.CRD_DEACTIVATED"
                (click)="makeAction(cardActions.CRD_EMIT)"
              >
                <i class="ri-bank-card-2-line"></i>
                {{ 'Ausgeben' | trans:'cards/card-details-modal/action-buttons/emit.Button' }}
              </button>
            } @else {
              <button
                class="button button--md button--primary-ghost text-uppercase p2 fw-semibold"
                [disabled]="isActionMaking() || data.card.status !== cardStatuses.CRD_VALID"
                (click)="makeAction(cardActions.CRD_REMIT)"
              >
                <i class="ri-bank-card-2-line"></i>
                {{ 'Zurücknehmen' | trans:'cards/card-details-modal/action-buttons/revoke.Button' }}
              </button>
            }
          </div>
        </div>

        <div>
          <p class="t2 c-t-gray-500 fw-medium text-uppercase">
            {{ 'CARD MANAGEMENT' | trans:'cards/card-details-modal/action-buttons/groups/card-management.Label' }}
          </p>

          <div class="m-t-8 d-flex flex-direction-column gap-12 align-items-start">
            @if (!data.card.customerId) {
              <button
                class="button button--md button--primary-ghost text-uppercase p2 fw-semibold"
                [disabled]="isActionMaking() || data.card.status !== cardStatuses.CRD_VALID || (data.card.status === cardStatuses.CRD_VALID && data.card.customerId)"
                (click)="customersSearchModalComponent.open()"
              >
                <i class="icon-webcash_credit_card_heart-icon"></i>
                {{ 'Personalisieren' | trans:'cards/card-details-modal/action-buttons/personalize.Button' }}
              </button>
            } @else {
              <button
                class="button button--md button--primary-ghost text-uppercase p2 fw-semibold"
                [disabled]="isActionMaking() || data.card.status !== cardStatuses.CRD_VALID || (data.card.status === cardStatuses.CRD_VALID && !data.card.customerId)"
                (click)="selectedCustomer = null; makeAction(cardActions.CRD_UNPERSONALIZE)"
              >
                <i class="icon-webcash_credit_card_heart-icon"></i>
                {{ 'Unpersonalisieren' | trans:'cards/card-details-modal/action-buttons/unpersonalize.Button' }}
              </button>
            }

            @if (data.card.status === cardStatuses.CRD_EXPIRED) {
              <button
                class="button button--md button--primary-ghost text-uppercase p2 fw-semibold"
                [disabled]="isActionMaking() || data.card.status !== cardStatuses.CRD_EXPIRED"
                (click)="makeAction(cardActions.CRD_RENEW)"
              >
                <i class="icon-webcash_credit_card_clock-icon"></i>
                {{ 'Verlangen' | trans:'cards/card-details-modal/action-buttons/request.Button' }}
              </button>
            } @else {
              <button
                class="button button--md button--primary-ghost text-uppercase p2 fw-semibold"
                [disabled]="isActionMaking() || data.card.status !== cardStatuses.CRD_VALID && data.card.status !== cardStatuses.CRD_BLOCKED"
                (click)="makeAction(cardActions.CRD_EXPIRE)"
              >
                <i class="icon-webcash_credit_card_clock-icon"></i>
                {{ 'Ablaufen lassen' | trans:'cards/card-details-modal/action-buttons/expire.Button' }}
              </button>
            }
          </div>
        </div>

        <div>
          <p class="t2 c-t-gray-500 fw-medium text-uppercase">
            {{ 'SECURITY & RISK' | trans:'cards/card-details-modal/action-buttons/groups/security.Label' }}
          </p>

          <div class="m-t-8 d-flex flex-direction-column gap-12 align-items-start">
            @if (data.card.status === cardStatuses.CRD_BLOCKED) {
              <button
                class="button button--md button--primary-ghost text-uppercase p2 fw-semibold"
                [disabled]="isActionMaking() || data.card.status !== cardStatuses.CRD_BLOCKED"
                (click)="makeAction(cardActions.CRD_UNBLOCK)"
              >
                <i class="ri-no-credit-card-line"></i>
                {{ 'Entsperren' | trans:'cards/card-details-modal/action-buttons/unlock.Button' }}
              </button>
            } @else {
              <button
                class="button button--md button--primary-ghost text-uppercase p2 fw-semibold"
                [disabled]="isActionMaking() || data.card.status !== cardStatuses.CRD_VALID"
                (click)="makeAction(cardActions.CRD_BLOCK)"
              >
                <i class="ri-no-credit-card-line"></i>
                {{ 'Sperren' | trans:'cards/card-details-modal/action-buttons/lock.Button' }}
              </button>
            }

            @if (data.card.status !== cardStatuses.CRD_LOST) {
              <button
                class="button button--md button--primary-ghost text-uppercase p2 fw-semibold"
                [disabled]="isActionMaking() || data.card.status !== cardStatuses.CRD_VALID"
                (click)="makeAction(cardActions.CRD_LOSE)"
              >
                <i class="icon-webcash_credit_card_question-icon"></i>
                {{ 'Verloren setzen' | trans:'cards/card-details-modal/action-buttons/mark-as-lost.Button' }}
              </button>
            } @else {
              <button
                class="button button--md button--primary-ghost text-uppercase p2 fw-semibold"
                [disabled]="isActionMaking() || data.card.status !== cardStatuses.CRD_LOST"
                (click)="makeAction(cardActions.CRD_FIND)"
              >
                <i class="icon-webcash_credit_card_question-icon"></i>
                {{ 'Wiederfinden' | trans:'cards/card-details-modal/action-buttons/restore.Button' }}
              </button>
            }
          </div>
        </div>

        <div>
          <p class="t2 c-t-gray-500 fw-medium text-uppercase">
            {{ 'Status' | trans:'cards/card-details-modal/action-buttons/groups/status.Label' }}
          </p>

          <div class="m-t-8 d-flex flex-direction-column gap-12 align-items-start">
            <button
              class="button button--md button--strong-ghost text-uppercase p2 fw-semibold"
              [disabled]="isActionMaking() || data.card.status === cardStatuses.CRD_DEACTIVATED"
              (click)="makeAction(cardActions.CRD_DEACTIVATE)"
            >
              {{ 'Deaktivieren' | trans:'cards/card-details-modal/action-buttons/deactivate.Button' }}
            </button>
          </div>
        </div>

        <div>
          <p class="t2 c-t-gray-500 fw-medium text-uppercase">
            {{ 'Print' | trans:'cards/card-details-modal/action-buttons/groups/print.Label' }}
          </p>

          <div class="m-t-8 d-flex flex-direction-column gap-12 align-items-start">
            <button
              class="button button--md button--primary-ghost text-uppercase p2 fw-semibold"
              [disabled]="isPrinting() || isActionMaking() || !data.card.canReprintCustomerCard"
              (click)="reprintCustomerCard()"
            >
              <i class="ri-printer-line"></i>
              {{ 'Reprint Customer Card' | trans:'cards/card-details-modal/action-buttons/reprint-customer-card.Button' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template
  #overviewTableRow
  let-label="label"
  let-value="value"
  let-withTopSeparator="withTopSeparator"
  let-withEditClientButton="withEditClientButton"
  let-isCardStatus="isCardStatus"
  let-isCurrentBalanace="isCurrentBalanace"
>
  <tr [class.top-separator]="withTopSeparator">
    <td width="300px">
      <div class="p1 c-t-blue-700">
        {{ label }}
      </div>
    </td>
    <td>
      <div class="p2">
        @if (isCardStatus) {
          <div
            class="tag card-status--{{ value }}"
          >
            {{ value | trans:'cards/card-details-modal/status/' + value }}
          </div>
        } @else if (isCurrentBalanace) {
          <div
            class="tag c-bg-blue-200"
          >
            {{ value | numberToCurrency }} {{ languageConfig.currency.short }}
          </div>
        } @else {
          {{ value | empty }}
        }
      </div>
    </td>
    <td class="text-right">
      @if (withEditClientButton) {
        <button
          class="button button--icon-sm button--primary-ghost"
          type="button"
          [disabled]="!data.card.customerId"
          (click)="customerDetailsModalComponent.open({ customerId: data.card.customerId })"
          appTooltip
          [delay]="tooltipDelay"
          content="{{ 'Edit customer' | trans:'cards/card-details/edit-customer.Tooltip' }}"
        >
          <i class="ri-user-settings-line"></i>
        </button>
      }
    </td>
  </tr>
</ng-template>

<app-customer-details-modal
  #customerDetailsModalComponent
  (formFinished)="data.card.customer = $event.customer; data.card.companyName = $event.companyName;"
/>

<app-customers-search-modal
  [showAnonymButton]="false"
  #customersSearchModalComponent
  (confirmCustomerSelection)="selectedCustomer = $event; makeAction(cardActions.CRD_PERSONALIZE)"
/>
